<script>
import { Bar } from 'vue-chartjs'
import { apiGet, notify } from '../util/general'
export default {
  extends: Bar,
  props : {
    tipo : {
      type   : String,
      default: 'garantia'
    },
    incluirCerrados : {
      type   : Boolean,
      default: false
    }
  },
  data () {
    return {
      listaData : [],
      chartData: {
        labels  : [],
        datasets: [
          {
            label          : `Cantidad`,
            data           : [],
            fill           : false,
            borderColor    : this.$vuetify.theme.themes.light.primary,
            backgroundColor: this.$vuetify.theme.themes.light.primary,
            borderWidth    : 1
          }
        ]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            gridLines: {
              display: true
            },
            ticks : {
              fontSize: 10
            }
          }]
        },
        onClick:this.handle,
        legend: {
          display: false
        },
        responsive         : true,
        maintainAspectRatio: false
      }
    }
  },
  created () {
    var vm = this;
    vm.fetchTicketsEnRecall()
  },
  methods : {
    handle (point, event) {
      var vm = this
      var item = event[0]
      if (item) {
        var index        = item._index
        // console.log('index', index)
        // var numero       = vm.listaData[index].numero
        vm.$emit('click', vm.listaData[index])
        // var url          = vm.$router.resolve({name  : 'detalle_ticket', params : { numero : numero }})
        // window.open(url.href, '_blank')
      }
    },
    render () {
      var vm = this
      vm.chartData.datasets[0].fill = !vm.$vuetify.theme.dark
      vm.renderChart(vm.chartData, vm.options)
    },
    fetchTicketsEnRecall () {
      var vm = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener listado de tickets abiertos en recall' })
      var obj = {
        tipo           : vm.tipo.toLowerCase(),
        incluirCerrados: vm.incluirCerrados ? 1 : 0
      }
      console.log('obj', obj)
      apiGet(vm, '/ticket/abiertos/count/recall', obj, function (data) {
        vm.$emit('count', data.labels.length)
        console.log('data', data)
        vm.listaData        = data.labels
        vm.chartData.datasets[0].data = []
        vm.chartData.labels = []
        for (var i = 0; i < data.valores.length; i++) {
          vm.chartData.datasets[0].data.push(data.valores[i])
        }

        for (var j = 0; j < data.labels.length; j++) {
          vm.chartData.labels.push(`${data.labels[j]}`)
        }

        vm.render()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
canvas
  max-height: 250px !important;
</style>



// WEBPACK FOOTER //
// c_chart_bar_tickets_en_recall.vue?f8ead950